export class PublishApi {
    constructor(settings) {
        this.url = settings.url;
        this.tilesUrl = settings.tilesUrl;
    }
    async getBranchCommitRoute(options) {
        let loc = "";
        for (const l in options.locations) {
            const location = options.locations[l];
            if (loc.length > 0)
                loc += "&";
            loc = loc + `loc=${location.lng},${location.lat}`;
        }
        loc = loc + "";
        const url = `${this.url}branch/commit/${options.branchCommitId}/routing?profile=${options.profile}&${loc}`;
        const response = await fetch(url, {
            signal: options.signal,
            headers: {
                "Content-Type": "application/json",
            }
        });
        if (!response.ok) {
            return {
                error: response.statusText,
                success: false,
            };
        }
        return {
            data: await response.json(),
            success: true,
        };
    }
    buildBranchCommitMvt(branchCommitId) {
        return `${this.tilesUrl}branch/commit/${branchCommitId}/tiles/mvt.json`;
    }
    buildBranchMvt(branchId) {
        return `${this.tilesUrl}${branchId}/tiles/mvt.json`;
    }
    async getProfilesForBranch(options) {
        const url = `${this.url}${options.branchId}/profiles`;
        const response = await fetch(url);
        return await response.json();
    }
    async postRoutesForBranchCommit(options, signal) {
        const parameters = {};
        if (options.maxIncrease > 0) {
            parameters.maxIncrease = options.maxIncrease;
        }
        const body = {
            profile: {
                name: options.profile,
                parameters: parameters
            },
            origins: options.origins.map(x => [x.lng, x.lat]),
            destinations: options.destinations.map(x => [x.lng, x.lat])
        };
        const url = `${this.url}branch/commit/${options.branchCommitId}/routing`;
        const response = await fetch(url, {
            method: "post",
            body: JSON.stringify(body),
            signal: signal,
            headers: {
                "Content-Type": "application/json"
            },
        });
        if (!response.ok) {
            return {
                error: response.statusText,
                success: false,
            };
        }
        return {
            data: await response.json(),
            success: true,
        };
    }
    async getSnapshotStatus(options) {
        const url = `${this.url}snapshot/${options.snapshotId}/status`;
        const response = await fetch(url);
        if (!response.ok) {
            if (response.status == 404)
                return undefined;
            throw new Error(response.statusText);
        }
        return await response.json();
    }
}
